import { buildProjectFilePayload, serializeProjectFilePayload } from "@plaatplan/core";
import { downloadText, slugifyProjectName } from "./download";

export function downloadProjectFile(project, layout) {
  const payload = buildProjectFilePayload(project, layout);
  const filename = `${slugifyProjectName(project.projectName)}-project.json`;
  downloadText(filename, serializeProjectFilePayload(payload), "application/json;charset=utf-8");
}
